<template>
    <validation-observer v-slot="{ validate }" slim>
        <form @submit.prevent="store(validate)">
            <client-form :form="form" :loading="loading" @store="store"/>
        </form>
    </validation-observer>
</template>
<script>
import ClientService from '@services/client.service';
import ClientForm from './components/Form';
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            form: {
                name: null,
                company_name: null,
                company_reg: null,
                company_email: null,
                email: null,
                phone: null,
                address: null,
                idcode: null,
                drivers_license: null,
                id_card: null,
                cc_no: null,
                cc_validity: null,
                discount_percent: 0,
                comments: null,
                newsletter: false,
                bond: false,
                tos: false,
            },
            loading: false
        };
    },
    watch: {
        locale() {
            this.resetFrom();
        }
    },
    computed: {
        ...mapGetters(['locale']),
    },
    methods: {
        store(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    ClientService.store(this.form).then(res => {
                        this.$toastr.s(this.$t('Saved'));
                        this.loading = false;
                        this.$router.push({name:'clients'});
                    });
                }
            });
        }
    },
    components: {
        ClientForm
    }
};
</script>
